import { render } from "./UnresolvedTicketsByPriority.vue?vue&type=template&id=005d6848&ts=true"
import script from "./UnresolvedTicketsByPriority.vue?vue&type=script&lang=ts"
export * from "./UnresolvedTicketsByPriority.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__